import React from "react";
import styles from "./TopBarTab.module.css";
import {
	titleXL,
	primaryTextColor,
	secondaryTextColor,
	fw500,
} from "../../../Global.module.css";

export default function TopBarTab({ active, title, action }) {
	const tabClass = active
		? `${styles.tab} ${styles.active}`
		: `${styles.tab}`;
	const textColor = active ? `${primaryTextColor}` : `${secondaryTextColor}`;
	return (
		<div className={tabClass} onClick={!action ? null : () => action()}>
			<p className={`${styles.title} ${titleXL} ${textColor} ${fw500}`}>
				{title}
			</p>
		</div>
	);
}
